import React from "react";
import PropTypes from "prop-types";
import LoadingSkeleton from "components/atoms/LoadingSkeleton/LoadingSkeleton";
import { Card as BootstrapCard } from "react-bootstrap";
import "./Card.scss";

interface ICardProps {
  children?: React.ReactNode;
  isLoading?: boolean;
  title?: React.ReactNode;
  id?: string;
  loadingSkeletonRowCount?: number;
  className?: string;
  height?: string;
  borderRadius?: string;
}

const CardNew = function ({
  children,
  isLoading,
  title,
  id,
  loadingSkeletonRowCount,
  className,
  height,
  borderRadius,
}: ICardProps) {
  return (
    <BootstrapCard
      className={className}
      id={id}
      style={{ borderRadius: borderRadius || 16, padding: 16, boxShadow: "none", height }}
    >
      {title && !isLoading && <h5 style={{ margin: "0px auto 16px auto" }}>{title}</h5>}
      {isLoading ? <LoadingSkeleton rows={loadingSkeletonRowCount} noShadow isListing /> : children}
    </BootstrapCard>
  );
};

CardNew.Header = BootstrapCard.Header;
CardNew.Footer = BootstrapCard.Footer;
CardNew.Text = BootstrapCard.Text;
CardNew.Body = BootstrapCard.Body;
CardNew.Title = BootstrapCard.Title;

CardNew.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  isLoading: PropTypes.bool,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  id: PropTypes.string,
  loadingSkeletonRowCount: PropTypes.number,
  height: PropTypes.string,
  borderRadius: PropTypes.string,
};

CardNew.defaultProps = {
  title: null,
  className: null,
  isLoading: false,
  id: null,
  children: null,
  loadingSkeletonRowCount: 1,
  height: "auto",
  borderRadius: "16px",
};

export default CardNew;
